/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { Modal, Spinner } from "react-bootstrap";
import styled from "styled-components";

export const ModalBodyContainer = styled(Modal.Body)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px 0 10px 0;
`;

export const SpinnerContainer = styled(Spinner)`
  margin-right: 15px;
`;
